const isMissing = (v) => v === undefined || v === null || v === "";

export const validateCreateRoute = (input) => {
  let isValid = true;
  if (isMissing(input?.origin)) {
    isValid = false;
  }
  if (isMissing(input?.destination)) {
    isValid = false;
  }
  return { isValid };
};
